export default {
  trigger: 'Invite restaurant owner',
  title: 'Invite the restaurant owner',
  description:
    'Create an account for the restaurant owner. They will receive an email with a temporary password to log in and finish setting up their restaurant.',
  fields: {
    first_name: 'First name',
    last_name: 'Last name',
    email: 'Email',
  },
  buttons: {
    invite: 'Send invite',
    cancel: 'Cancel',
  },
  toasts: {
    invited: '{{email}} has been invited to finish the setup.',
    failed: 'Could not create the owner account. Please try again.',
  },
};
